<template>
  <router-view/>
</template>

<script>
    export default {
        name: "EmptyRouterView"
    }
</script>